import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { Result } from '../interfaces/Result'

interface CA02EmailPasswordResetProps {
  execEmailPasswordReset: (email: string) => Promise<Result>
  loading: loadStatus
}
// CA02 パスワードリセットメール送信
export const useCA02EmailPasswordReset = (): CA02EmailPasswordResetProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)

  const execEmailPasswordReset = async (email: string) => {
    try {
      setLoading(loadStatus.LOADING)
      // ヘッダ作成
      const header = axiosDefaultHeader
      // ボディ作成
      const body = {
        email: email,
      }

      const response = await axios.post(
        `${baseUrl}${stage}${apiUrl.emailPath}password-reset`,
        body,
        {
          headers: header,
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        // console.log(response.data);
        setLoading(loadStatus.LOADED)
        return { success: true }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execEmailPasswordReset, loading }
}
